import { projectSchema } from './schemas/video-project';
export function validateProject(input) {
    const result = projectSchema.safeParse(input);
    if (result.success) {
        return { valid: true, issues: [] };
    }
    const issues = result.error.issues.map((issue) => ({
        severity: 'error',
        code: issue.code,
        message: issue.message,
        path: issue.path.join('.'),
    }));
    return { valid: false, issues };
}
export function parseProject(input) {
    const result = projectSchema.safeParse(input);
    if (result.success) {
        return { success: true, data: result.data, issues: [] };
    }
    const issues = result.error.issues.map((issue) => ({
        severity: 'error',
        code: issue.code,
        message: issue.message,
        path: issue.path.join('.'),
    }));
    return { success: false, issues };
}
export function validateProjectSemantics(project) {
    const issues = [];
    const assetIds = new Set(project.assets.map((a) => a.id));
    for (const scene of project.scenes) {
        for (const shot of scene.shots) {
            const refs = [...(shot.subjects ?? []), ...(shot.environment ?? [])];
            for (const ref of refs) {
                if (!assetIds.has(ref.assetId)) {
                    issues.push({
                        severity: 'error',
                        code: 'missing_asset',
                        message: `Shot ${shot.id} references missing asset ${ref.assetId}`,
                        path: `scenes.${scene.id}.shots.${shot.id}`,
                    });
                }
            }
            for (const clip of shot.audio ?? []) {
                if (!assetIds.has(clip.assetId)) {
                    issues.push({
                        severity: 'error',
                        code: 'missing_audio_asset',
                        message: `Shot ${shot.id} references missing audio asset ${clip.assetId}`,
                        path: `scenes.${scene.id}.shots.${shot.id}.audio`,
                    });
                }
            }
        }
    }
    let _expectedSceneStart = 0;
    for (const scene of project.scenes) {
        let expectedShotStart = 0;
        for (const shot of scene.shots) {
            if (Math.abs(shot.start - expectedShotStart) > 0.001) {
                issues.push({
                    severity: 'warning',
                    code: 'shot_gap',
                    message: `Shot ${shot.id} has gap/overlap: expected start ${expectedShotStart}, got ${shot.start}`,
                    path: `scenes.${scene.id}.shots.${shot.id}`,
                });
            }
            expectedShotStart = shot.start + shot.duration;
        }
        const sceneDuration = scene.duration;
        if (sceneDuration !== undefined && Math.abs(expectedShotStart - sceneDuration) > 0.001) {
            issues.push({
                severity: 'warning',
                code: 'scene_duration_mismatch',
                message: `Scene ${scene.id} duration ${sceneDuration} != shots total ${expectedShotStart}`,
                path: `scenes.${scene.id}`,
            });
        }
        _expectedSceneStart += expectedShotStart;
    }
    return { valid: issues.filter((i) => i.severity === 'error').length === 0, issues };
}
export function validate(input) {
    const syntactic = validateProject(input);
    if (!syntactic.valid)
        return syntactic;
    return validateProjectSemantics(syntactic.valid ? input : {});
}
//# sourceMappingURL=validate.js.map